type ToggleFavoritesProps = {
  prompt: string
  isFavorite: boolean
  favoriteMessages: string[]
  setFavoriteMessages: React.Dispatch<React.SetStateAction<string[]>>
};

const toggleFavorites = ({
  prompt,
  isFavorite,
  favoriteMessages,
  setFavoriteMessages,
}: ToggleFavoritesProps) => {
  if (isFavorite) {
    setFavoriteMessages(favoriteMessages.filter(item => item !== prompt));
  } else {
    // only add if not already in the list
    if (!favoriteMessages.includes(prompt)) {
      setFavoriteMessages(favoriteMessages => [...favoriteMessages, prompt]);
    }
  }
};

export default toggleFavorites;